import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AppContext';
import { USER_ROLE } from '../utils/constants';
import { PATHS, portalPathForRole } from '../navigation/paths';
import { isPortalAccessGranted } from '../utils/historySession';
import Logo from '../components/ui/Logo';

/**
 * Oturum ve rol koruması — yalnızca route guard sorumluluğu (SRP).
 */
const RequireAuth = ({ children, role = null }) => {
  const { loggedInUser, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-slate-50 dark:bg-slate-900">
        <Logo size={56} variant="nav" />
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-emerald-600 border-t-transparent" />
      </div>
    );
  }

  if (!loggedInUser || !isPortalAccessGranted(loggedInUser.id)) {
    return <Navigate to={PATHS.LOGIN} state={{ from: location }} replace />;
  }

  if (role && loggedInUser.role !== role) {
    return <Navigate to={portalPathForRole(loggedInUser.role)} replace />;
  }

  return children;
};

export const RequireStudent = ({ children }) => (
  <RequireAuth role={USER_ROLE.STUDENT}>{children}</RequireAuth>
);

export const RequireInstructor = ({ children }) => (
  <RequireAuth role={USER_ROLE.INSTRUCTOR}>{children}</RequireAuth>
);

export default RequireAuth;
